{
  "login": {
    "title": "Welcome back",
    "subtitle": "Sign in to continue.",
    "email": "Email",
    "password": "Password",
    "remember": "Remember me",
    "submit": "Sign in",
    "forgot": "Forgot password?",
    "invalid": "Invalid credentials",
    "required": "Email and password are required"
  },
  "forgot": {
    "title": "Reset your password",
    "subtitle": "Enter your email and we’ll send a reset link.",
    "email": "Email",
    "submit": "Send reset link",
    "back": "Back to sign in",
    "sent": "If that email exists, a reset link has been sent."
  },
  "reset": {
    "title": "Choose a new password",
    "subtitle": "Enter a new password for your account.",
    "password": "New password",
    "confirm": "Confirm password",
    "submit": "Set new password",
    "back": "Back to sign in",
    "success": "Your password has been changed. You can now sign in.",
    "signin": "Go to sign in",
    "mismatch": "The two passwords don’t match.",
    "tooShort": "Password must be at least 8 characters.",
    "missingToken": "This reset link is invalid or incomplete. Request a new one.",
    "invalidToken": "This reset link is invalid or has expired. Request a new one."
  },
  "dashboard": {
    "welcome": "Welcome, {name}",
    "subtitle": "Here’s your school at a glance.",
    "placeholder": "Your dashboard widgets will appear here as you add students, classes, and events."
  },
  "portalLogin": {
    "title": "Student Portal",
    "subtitle": "Sign in to see your classes and progress.",
    "submit": "Sign in"
  }
}
